/**
 * Клиент синхронизации с Битриксом (серверные endpoints /api/bitrix/*).
 * Точечная загрузка одной сделки — чтобы при открытии вкладки «Календарь ERP»
 * в карточке сделки она появлялась сразу, не дожидаясь фонового опроса (60 сек).
 */
import { authHeaders, notifyUnauthorized } from '@/auth/session';

const BASE = '/api';

async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      Accept: 'application/json',
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...authHeaders(),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) notifyUnauthorized();
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((json as any)?.error || `HTTP ${res.status}`);
  return json as T;
}

/** Подтянуть одну сделку из Битрикса прямо сейчас (id может быть «bx123» или «123»). */
export const syncOneDealNow = (bitrixId: string) =>
  req<{ created: boolean; present: boolean; reason?: string }>('POST', `/bitrix/sync-deal/${bitrixId}`);

/** Разовый импорт всех подходящих сделок из CRM Битрикса. */
export const importAllFromBitrix = () =>
  req<{ scanned: number; created: number; skipped: number; errors: string[] }>('POST', '/bitrix/import-all');

/** A9 «Ручная привязка»: связать ручное ERP-событие со сделкой Битрикса (по ID или телефону). */
export const linkDealToBitrix = (erpId: string, opts: { bitrixId?: string; phone?: string }) =>
  req<{ ok: boolean; bitrixId?: string; reason?: string }>('POST', `/bitrix/link-deal/${erpId}`, opts);
